<button class="plus-btn"
        (click)="onClick()"
        [ngClass]="{ 'indeterminate': indeterminate }">
  <span class="p-line"
        [ngStyle]="{ 'transform': active && !indeterminate ? 'rotateZ(90deg)' : 'rotateZ(0deg)' }"> </span>
  <span class="p-line"></span>
</button>
